import { useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { VideoCard } from './VideoCard';

export function GenreRow({ title, items, sectionTestId }) {
    const railRef = useRef(null);
    const scrollBy = (dir) => {
        const el = railRef.current;
        if (!el) return;
        el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: 'smooth' });
    };
    if (!items || items.length === 0) return null;
    return (
        <section data-testid={sectionTestId || `row-${title}`} className="relative">
            <div className="flex items-end justify-between mb-3 px-1">
                <h2 className="font-display text-xl md:text-2xl font-semibold">{title}</h2>
                <div className="hidden md:flex gap-1">
                    <Button onClick={() => scrollBy(-1)} variant="ghost" size="icon" className="h-8 w-8 rounded-full bg-[color:var(--alb-surface)]/60 hover:bg-[color:var(--alb-surface)]"><ChevronLeft className="h-4 w-4" /></Button>
                    <Button onClick={() => scrollBy(1)} variant="ghost" size="icon" className="h-8 w-8 rounded-full bg-[color:var(--alb-surface)]/60 hover:bg-[color:var(--alb-surface)]"><ChevronRight className="h-4 w-4" /></Button>
                </div>
            </div>
            <div ref={railRef} className="no-scrollbar flex gap-3 md:gap-4 overflow-x-auto snap-x pb-2">
                {items.map((v) => (
                    <div key={v.video_id} className="snap-start shrink-0 w-[78vw] sm:w-[42vw] md:w-[280px] lg:w-[300px]">
                        <VideoCard video={v} />
                    </div>
                ))}
            </div>
        </section>
    );
}
